import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./components/auth/Login";
import AppRoutes from "./components/routing/Routes";
import ResponseInterceptor from "../src/utils/interceptor";
import { connect } from "react-redux";
import { LOGIN_SUCCESS, GET_TENANT_INFO } from "./action/types";
import setAuthToken from "./utils/setAuthToken";
import setTenantId from "./utils/setTenantId";
import "./App.css";
import CircularProgress from "@mui/material/CircularProgress";
import { ThemeProvider } from "@mui/material/styles";
import { updateDesignSystem } from './theme/designSystemStore';
import { muiTheme } from './theme/muiTheme';
import ResponsiveGlobalStyles from './theme/ResponsiveGlobalStyles';
import NavigationAlertReset from "./components/layout/NavigationAlertReset";

const App = ({ tenantInfo, dispatch }) => {
  const [appReady, setAppReady] = useState(false);

  useEffect(() => {
    ResponseInterceptor();

    const storedAuth = localStorage.getItem("authInfo");
    const tenantInfo = localStorage.getItem("tenantInfo");

    if (tenantInfo) {
      dispatch({
        type: GET_TENANT_INFO,
        payload: JSON.parse(tenantInfo),
      });
      setTenantId(tenantInfo.tenantId);
    }

    if (storedAuth) {
      const parsedAuth = JSON.parse(storedAuth);
      dispatch({ type: LOGIN_SUCCESS, payload: parsedAuth });
      setAuthToken(parsedAuth.accessToken);
    }

    setAppReady(true);
  }, [dispatch]);

  useEffect(() => {
    if (tenantInfo) {
      updateDesignSystem(tenantInfo);
    }
  }, [tenantInfo]);

  useEffect(() => {
    const favicon = document.getElementById("favicon");
    favicon.setAttribute("href", tenantInfo.tenantFaviconUrl);
    // favicon.href = logo;
  }, [tenantInfo.tenantFaviconUrl]);

  let className = "main-wrapper ";
  if (tenantInfo.primaryColor) {
    className +=
      tenantInfo.primaryColor +
      "-theme " +
      tenantInfo.secondaryColor +
      "-theme-secondary ";
  } else {
    className += "blue-theme lime-theme-secondary ";
  }

  if (
    tenantInfo.selectedTheme &&
    ["round", "rectangular"].includes(tenantInfo.selectedTheme.toLowerCase())
  ) {
    className += tenantInfo.selectedTheme.toLowerCase() + " roundOrRectangular";
  }

  if (!appReady) {
    return (
      <div
        style={{
          display: "grid",
          placeItems: "center",
          height: "80vh",
        }}
      >
        <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
      </div>
    );
  }

  return (
    <ThemeProvider theme={muiTheme}>
      <ResponsiveGlobalStyles />
      <BrowserRouter>
        <NavigationAlertReset />
        <section className={className}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/*" element={<AppRoutes />} />
          </Routes>
        </section>
      </BrowserRouter>
    </ThemeProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    tenantInfo: state.tenant.tenantInfo,
  };
};

export default connect(mapStateToProps)(App);
